export const name = 'UnsubscribeController';
export default function UnsubscribeController(
  // Controller angular dependencies
  $state,
  $stateParams,
  rnHttp,
  $translate,
  $gzGo
) {
  'ngInject';
  // Constants

  // Variables

  // View Model
  let vm = this;
  vm.loading = true;
  vm.unsubscribe = unsubscribe;
  vm.goToSignIn = goToSignIn;
  vm.goToEmailSettings = goToEmailSettings;
  vm.$onInit = onInit;

  return;

  function onInit() {
    parseParams();
    vm.loading = false;
  }

  function parseParams() {
    vm.subscription = {};

    //vm.subscription.email = _.get($stateParams, 'email');
    vm.subscription.userId = _.get($stateParams, 'userId');
    vm.subscription.category = _.get($stateParams, 'category');

    if (!vm.subscription.category) {
      vm.subscription.categoryDisplay = $translate.instant('register.register.NotDefined');
    }
    else {
      vm.subscription.categoryDisplay = $translate.instant('register.register.' + vm.subscription.category);
    }
  }

  function unsubscribe() {
    vm.submitting = true;

    return rnHttp.post('email_service', 'unsubscriber/unsubscribe/' + vm.subscription.category, vm.subscription.userId)
      .then(response => {
        vm.unsubscribed = true;
      })
      .catch(error => {
        vm.errorKey = 'register.register.UnsubscribeError';
      })
      .finally(() => {
        vm.submitting = false;
      });

  }

  function goToSignIn($event) {
    $event.stopPropagation();
    vm.submitting = true;
    $state.go('signin');
  }

  function goToEmailSettings($event) {
    $event.stopPropagation();
    $gzGo.toContext('email-subscriptions');
  }
}



// WEBPACK FOOTER //
// ./components/unsubscribe/unsubscribe.controller.js